import React from "react";
import navBkg from "../../assets/images/profileNavStock.png";
import { Link } from "react-router-dom";
import { Grid, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  navList: {
    backgroundColor: "#104D82",
  },
  navImg: {
    backgroundImage: `url(${navBkg})`,
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
  },
  navButtonActive: {
    textDecoration: "none",
    color: "#ffffff",
  },
  navButton: {
    textDecoration: "none",
    color: "rgba(255, 255, 255, 0.70)",
  },
});

export default function ProfileNav() {
  const styles = useStyles();

  return (
    <Grid container height="100%">
      <Grid
        container
        item
        xs={5}
        md={window.location.pathname !== "/profile/users" ? 5 : 12}
        pt={6}
        className={styles.navList}
        justifyContent="center"
      >
        <Stack spacing={4}>
          <Link
            to="/profile/edit"
            className={
              window.location.pathname === "/profile/edit"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>My Profile</Typography>
          </Link>{" "}
          <Link
            to="/profile/projects"
            className={
              window.location.pathname === "/profile/projects"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>My Projects</Typography>
          </Link>{" "}
          <Link
            to="/profile/users"
            className={
              window.location.pathname === "/profile/users"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>Users</Typography>
          </Link>
          <Link
            to="/profile/account"
            className={
              window.location.pathname === "/profile/account"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>Account Settings</Typography>
          </Link>
        </Stack>
      </Grid>

      {window.location.pathname !== "/profile/users" ? (
        <Grid item xs={7} className={styles.navImg}></Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
}
